import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';
import { MzicPopoverComponent } from '../mzic-popover';
import { MzicSvgComponent } from '../mzic-svg/mzic-svg.component';

@Component({
  selector: 'mzic-switch-language',
  imports: [CommonModule, MzicSvgComponent, MzicPopoverComponent, ClickOutsideDirective],
  templateUrl: './switch-language.component.html',
  styleUrl: './switch-language.component.scss',
})
export class SwitchLanguageComponent implements OnInit {
  protected languageActive = 'en';
  protected showPopover = false;
  @Output() languageChange = new EventEmitter<string>();
  translocoService = inject(TranslocoService);

  ngOnInit() {
    this.translocoService.langChanges$.subscribe((lang) => {
      this.languageActive = lang;
    });
  }

  switchLanguage(lang: string) {
    this.languageChange.emit(lang);
  }

  togglePopover() {
    this.showPopover = !this.showPopover;
  }

  closePopover() {
    this.showPopover = false;
  }

  selectLanguage(lang: string) {
    this.switchLanguage(lang);
    this.closePopover();
  }
}
